import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Form, } from 'react-bootstrap'



import { useDispatch, useSelector } from 'react-redux'
import {  fetchPostCustomers } from '../actions/productActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { Link, useNavigate } from 'react-router-dom'


import { userLogoutAction } from '../actions/userActions'
import exportToExcel from '../utils/ExportToExcel'
import ToJalaali from '../utils/ToJalaali'
import { BASE_URL } from '../constants/urlConstants'
import PersianText from '../components/PersianText'

function PostScreen() {

  const history = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const listPostCustomers = useSelector(state => state.listPostCustomer)
  const { error, loading, postCustomer } = listPostCustomers

  const TE = "Invalid token specified: must be a string"

  useEffect(() => {
    if (error === TE) {
      dispatch(userLogoutAction());
      history('/login?redirect=/profile');
    }
    if (!userInfo) {
      history('/login')
    }
  }, [history, userInfo, dispatch, error])

  const [selectedOption, setSelectedOption] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [selectedCode, setselectedCode] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [message, setMessage] = useState('')

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault()//صفحه ریلود نمیشود
    if (!selectedOption && !selectedCode) {
      setMessage('لطفا یک مورد را انتخاب کنید !')
    } else {
      setMessage('')
      if (selectedOption) {
        dispatch(fetchPostCustomers(selectedOption))
      } else {
        dispatch(fetchPostCustomers(selectedCode))
      }
      setSelectedOption('')
      setselectedCode('')
    }
  }


  const tableData = postCustomer.map((item, index) => ({
    "ردیف": index + 1,
    "کد رهگیری": item.track_code,
    "نام": item.customer?.name,
    "پک مربوطه": item.categoryKit,
    "تاریخ پرداخت": ToJalaali(item.paidAt),
    " آماده ارسال": ToJalaali(item.readyAt),
    "تاریخ تحویل": ToJalaali(item.deliveredAt),
    "عدم تحویل": ToJalaali(item.problemAt),
    "توضیحات": item.description,
    "شماره تماس": item.customer?.phone_number,
    "کدپستی": item.addresses?.newPostalcode || '—',
    "محدوده": item.customer?.area?.name,
    "آدرس": item.addresses?.newAddress || '—',
    
  }))


  const handlePrint = () => {
    window.print();
  };


  console.log(userInfo.name)
  return (

    <div>
      {
        loading ? <Loader />
          : error ? <Message variant='danger' text={error} />
            : message ? <Message variant='danger' text={message} />
              : <></>
      }
      <p className='text-danger large mt-3'>گزارش تحویل :</p>
      <Row>
        <form onSubmit={handleSubmit}>
          <Col md={12}>
            <Row>
              <Col md={3} className='pt-3'>
                <div>

                  <input
                    type="radio"
                    name="option"
                    value="8"
                    checked={selectedOption === "8"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    پرداخت شده
                  </label>
                </div>
                <div>

                  <input
                    type="radio"
                    name="option"
                    value="9"
                    checked={selectedOption === "9"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    آماده ارسال
                  </label>
                </div>

              </Col>
              <Col md={3} className='pt-3'>

                <div>

                  <input
                    type="radio"
                    name="option"
                    value="10"
                    checked={selectedOption === "10"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    تحویل شده
                  </label>
                </div>
                <div>

                  <input
                    type="radio"
                    name="option"
                    value="11"
                    checked={selectedOption === "11"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    اشکال در تحویل
                  </label>
                </div>
              </Col>
              
              {userInfo.name == "mina" ? (
              <Col md={3} className='pt-3'>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="12"
                        checked={selectedOption === "12"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        همه موارد
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="13"
                        checked={selectedOption === "13"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        پرداخت نشده
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="14"
                        checked={selectedOption === "14"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        درانتظار پرداخت
                      </label>
                    </div>
               
              </Col>
               ) : ""}
                <Col md={3} className='pt-2'>    
                <div>
                  <Form.Group controlId='trackcode'>
                    <Form.Label></Form.Label>
                    <Form.Control
                      type='text'
                      name="option"
                      placeholder='کد رهگیری'
                      value={selectedCode}
                      onChange={(e) => setselectedCode(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </div>
              </Col>
            </Row>
            <Row>
              <div className="d-grid gap-2 d-md-block col-3 p-3">
                <button className="btn btn-primary" type="submit">نمایش</button>
              </div>
            </Row>
          </Col>
        </form>
      </Row>
      <Row>
        <Col>
          <img src={`${BASE_URL}/public/images/logo/exel-icon.png`} onClick={() => exportToExcel(tableData, "table-data")} alt="icon" class="icon"></img>

          <img src={`${BASE_URL}/public/images/logo/print-icon.png`} onClick={handlePrint} alt="icon" class="icon"></img>
        </Col>
      </Row>
      <Row>

        <Table className="table table-sm table-bordered table-warning table-striped table-hover" id="table-to-print">
          <thead>
            <tr className='table-warning'>
              <td className='table-warning text-danger'>ردیف</td>
              <td className='table-warning text-danger'>کد رهگیری</td>
              <td className='table-warning text-danger'>نام</td>
              <td className='table-warning text-danger'>پک مربوطه</td>
              <td className='table-warning text-danger'>تاریخ پرداخت</td>
              <td className='table-warning text-danger'>آماده ارسال</td>
              <td className='table-warning text-danger'>تاریخ تحویل</td>
              <td className='table-warning text-danger'> عدم تحویل</td>
              <td className='table-warning text-danger'>توضیحات</td>

              <td className='table-warning text-danger'>شماره تماس</td>
              <td className='table-warning text-danger'>کدپستی</td>
              <td className='table-warning text-danger'>محدوده</td>
              <td className='table-warning text-danger'>آدرس</td>
            </tr>
          </thead>
          <tbody>
            {postCustomer.map((items, index) => (
              <tr className='table-warning'>
                <td className='table-warning'>{index + 1}</td>
                <td className='table-warning'>
                  
                    <PersianText> {items.track_code}</PersianText>
                 
                </td>
                <td className='table-warning'>{items.customer?.name}</td>

                <td className='table-warning'><PersianText>کیت شماره {items.categoryKit}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.paidAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.readyAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.deliveredAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.problemAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{items.description}</PersianText></td>

                <td className='table-warning'><PersianText>{items.customer?.phone_number}</PersianText></td>
                <td className='table-warning'><PersianText>{items.addresses?.newPostalcode || '—'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.customer?.area?.name}</PersianText></td>
                <td className='table-warning'><PersianText>{items.addresses?.newAddress || '—'}</PersianText></td>
              </tr>
            ))}
          </tbody>
        </Table>

      </Row>

    </div>



  );
}

export default PostScreen
